import axios from "../../axiosDod.js";
const addDodFile = async (_, data) => {
  const formData = new FormData();
  const file = data.file;
  formData.append("file", file);
  const response = await axios.post(`cdn/upload`, formData);
  return response.data.fileId;
};

const getDodFile = async (_, fileId) => {
  const response = await axios.get(`cdn/${fileId}`);
  return response.data;
};

const getDodFileBlob = async (_, fileId) => {
  const response = await axios.get(`cdn/${fileId}`, {
    responseType: "blob",
  });
  return response.data;
};

const removeDodFile = async (_, fileId) => {
  const response = await axios.delete(`cdn/${fileId}`);
  return response.data;
};

export default {
  addDodFile,
  getDodFile,
  removeDodFile,
  getDodFileBlob,
};
